import React, { Component } from 'react';
import DocumentTitle from "react-document-title";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import { NavLink } from "react-router-dom";
import './index.css'
import BsySlidePane from "../BsySlidePane";
import CeateKey from "./CeateKey";
import BsyDialog from "../BsyDialog";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import wushujutuisong from "../../images/img_wushujutuisong@2x.png";
import imgkfptweihuoqu from "../../images/img_kfpt_weihuoqu@2x.png";
import { setPageTitle } from '../../utils/setPageTitle';

class BsyWebhookKey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keyList: [],
            openapi: false,
            success: false,
            createAllName: "",
        }
    }
    componentDidMount() {
        this.onLoadList()
    }

    leftTitle = () => {
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    dashboardMenuCenterMenu = () => {
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="form-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }

    onLoadList = () => {
        React.axios("/webapi/key_list", {}).then(res => {
            let keyList = [];
            res.data.data.map(res => {
                res.inputType = false;
                keyList.push(res)
            })
            this.setState({
                openapi: res.data.openapi,
                keyList,
                success: true
            })
        })
    }

    CeateKey = () => {
        BsySlidePane({
            title: React.language('webhook.key.create'),
            hasHeader: false,
            onContentCreate: (ref) => {
                return <CeateKey alertDom={ref} type="create" onLoadList={this.onLoadList} />
            },
        })
    }

    switchInputType = (k) => {
        return () => {
            const { keyList } = this.state;
            keyList[k].inputType = !keyList[k].inputType;
            this.setState({
                keyList
            })
        }
    }

    editKey = (res) => {
        return () => {
            BsySlidePane({
                hasHeader: false,
                onContentCreate: (ref) => {
                    return <CeateKey alertDom={ref} type="detail" mode={res.type} name={res.name} keys={res.key} kId={res.keyid} onLoadList={this.onLoadList} title={React.language('webhook.key.detail')} />
                },
            })
        }
    }

    changeAllKeyName = (event) => {
        this.setState({
            createAllName: event.target.value
        })
    }


    createAllKey = () => {
        BsyDialog({
            title: React.language("webhook.key.create"),
            height: 313,
            width: 460,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                this.setState({
                    createAllName: ""
                })
                return <div className="createAllKey">
                    <div className="keyTitle">
                        {
                            React.language("webhook.key.name1")
                        }
                    </div>
                    <div className="keyInput">
                        <input type="text" placeholder={React.language('webhook.key.all.placeholder')} onChange={this.changeAllKeyName} />
                    </div>
                    <div className="keyMsg">
                        {
                            React.language('webhook.key.all.msg')
                        }
                    </div>
                </div>
            },
            onOk: () => {
                if (!this.state.createAllName) {
                    tipAlert({
                        type: "warning",
                        msg: React.language('webhook.key.all.error')
                    })
                    return false
                }
                React.axios("/webapi/update", { name: this.state.createAllName, type: 0 }).then(res => {
                    tipAlert({
                        type: "success",
                        msg: React.language('api.CeateKey.success')
                    })
                    this.onLoadList()
                })
            }
        })
    }

    resetKey = (k) => {
        return () => {
            const { keyList } = this.state;
            BsyAlert({
                title: React.language("webhook.re.key", {
                    name: keyList[k].name
                }),
                type: "error-input",
                text4Ok: React.language("richtext.reset"),
                placeholder: React.language("webhook.re.key.placeholder"),
                OkType: "red",
                onInputValidate: (val) => {
                    return val === keyList[k].name
                },
                text4Cancel: React.language("cancel"),
                ok: (value, ref) => {
                    if (value === keyList[k].name) {
                        React.axios('/webapi/update', { type: 2, keyid: keyList[k].keyid }).then(res => {
                            keyList[k].key = res.data.data.key;
                            this.setState({
                                keyList
                            })
                        })
                        ref.classList.remove("error")
                        return true;
                    } else {
                        tipAlert({
                            type: "error",
                            msg: React.language('webhook.re.key.tip')
                        })
                        ref.classList.add("error")
                        return false;
                    }
                }
            })
        }
    }

    removeKey = (res) => {
        return () => {
            BsyAlert({
                title: React.language("webhook.key.del.title", {
                    name: res.name
                }),
                type: "warning",
                text4Ok: React.language("delete"),
                OkType: "red",
                text4Cancel: React.language("cancel"),
                ok: (value) => {
                    React.axios('/webapi/delete', {
                        keyid: res.keyid
                    }).then(res => {
                        tipAlert({
                            type: "success",
                            msg: React.language('delete.success')
                        })
                        this.onLoadList()
                    }).catch(res => {
                        console.error(res);
                    })
                    return true;
                }
            })
        }
    }

    render() {
        const { keyList, openapi, success } = this.state;
        setPageTitle("开放平台 - 密钥管理");
        return (

            <div className="BsyWebhookKey">
                <BsyDashboardMenu dashboardMenuCenterMenu={this.dashboardMenuCenterMenu} leftTitle={this.leftTitle} />
                {success && <>
                    {(keyList.length > 0 || openapi) ? <div className="keyManagement">
                        <div className="keyHeader">
                            <div className="keyTitle">
                                API Key
                            </div>

                            {openapi && <div className="createKeyBtn">
                                <div className="keyBtn create" onClick={this.createAllKey}>
                                    <i className="icon-add1" />
                                    <span>{React.language('webhook.key.create')}</span>
                                </div>
                                <div className="keyBtn customize" onClick={this.CeateKey}>
                                    <i className="icon-bsy-reportmenu-1" />
                                    <span>{React.language('webhook.key.customize')}</span>
                                </div>
                            </div>}
                        </div>
                        <div className="keyCont">
                            <div className="keyCont-title">
                                <div className="title-cel">
                                    {React.language('receipt.fullName')}
                                </div>
                                <div className="title-cel">
                                    API Key
                                </div>
                                <div className="title-cel">
                                    {React.language('type')}
                                </div>
                                <div className="title-cel">
                                    {React.language('order.operation')}
                                </div>
                            </div>
                            <div className="keyList">
                                {
                                    keyList.map((res, key) => {
                                        return <div className="keyItem">
                                            <div className="item-cel name" title={res.name}>
                                                <span>
                                                    {res.name}
                                                </span>
                                            </div>
                                            <div className="item-cel keyPassword">
                                                <div className="keyPasswordContent">
                                                    <input type={res.inputType ? "text" : "password"} value={res.key} />
                                                    <div className="inputBtn">
                                                        <div className="switchInputType" onClick={this.switchInputType(key)}>
                                                            <i className={res.inputType ? "icon-bsy-filter-hide" : "icon-bsy-filter-show"} />
                                                        </div>
                                                        <div className="resetBtn" onClick={this.resetKey(key)}>
                                                            {
                                                                React.language('richtext.reset')
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item-cel type">
                                                {res.type === "1" ? React.language('sso.custom.api') : React.language('webhook.key.all')}
                                            </div>
                                            <div className="item-cel operation">
                                                <div className="keyBtn detail" onClick={this.editKey(res)}>
                                                    {
                                                        React.language('detail')
                                                    }
                                                </div>
                                                <div className="keyBtn remove" onClick={this.removeKey(res)}>
                                                    {
                                                        React.language('remove')
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div> : <div className="keyManagementEmpty">
                        <div className="emptyCont">
                            <div className="keyManagementEmptyContent">
                                <div className="emptyImg">
                                    <img style={{ width: openapi ? "108px" : "260px" }} src={openapi ? wushujutuisong : imgkfptweihuoqu} alt="" />
                                </div>
                                <div className="emptyTip">
                                    <span>{openapi ? React.language("webhook.key.empty.tip") : React.language("purview.webhook.tip1")}</span>
                                </div>
                            </div>
                        </div>
                    </div>}
                </>}

            </div>

        );
    }
}

export default BsyWebhookKey;